export default __webpack_public_path__ + "static/210528_夏日角色熱更預告_tc-5e15ec6c5d952a3e4ff46d696047b4ac.webp";